(function () {
  'use strict';
  if (window.CinemaDecoBespoke) { window.CinemaDecoBespoke.boot(); return; }
  var products = new Map();
  var pages = new WeakSet();

  function selected(control) {
    if (!control) return '';
    var field = control.querySelector('input[type="radio"]:checked, select');
    return field ? field.value : '';
  }
  function control(picker, name) {
    return Array.from(picker.querySelectorAll('fieldset.product-form__input, div.product-form__input')).find(function (field) {
      var label = field.querySelector('legend, .form__label');
      return label && label.textContent.trim().toLowerCase().indexOf(name) === 0;
    });
  }
  function safeSource(value) {
    try {
      var url = new URL(value, location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) return '';
      return url.origin + url.pathname;
    } catch (error) { return ''; }
  }
  function setContext(form, context) {
    if (!form) return;
    var model = form.querySelector('[data-bespoke-model]');
    if (model && !model.dataset.customerEdited) model.value = context.model || '';
    [['configuration', context.configuration], ['covering', context.covering], ['source', safeSource(context.source)]].forEach(function (item) {
      var input = form.querySelector('[data-bespoke-' + item[0] + ']');
      if (input) input.value = item[1] || '';
    });
    var summary = form.querySelector('[data-bespoke-context]');
    if (summary) {
      var parts = [context.configuration, context.covering].filter(Boolean);
      summary.textContent = parts.length ? 'Currently viewing: ' + parts.join(' · ') : '';
      summary.hidden = !parts.length;
    }
  }
  function pageUrl(root, context) {
    var fallback = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'pages/bespoke-seating';
    var url;
    try { url = new URL(root.dataset.bespokePageUrl || fallback, location.origin); }
    catch (error) { url = new URL(fallback, location.origin); }
    if (url.origin !== location.origin) url = new URL(fallback, location.origin);
    [['model', context.model], ['configuration', context.configuration], ['covering', context.covering], ['source', safeSource(context.source)]].forEach(function (item) {
      if (item[1]) url.searchParams.set(item[0], item[1]);
      else url.searchParams.delete(item[0]);
    });
    return url.pathname + url.search + url.hash;
  }
  function rememberModelEdits(form) {
    var field = form && form.querySelector('[data-bespoke-model]');
    if (field) field.addEventListener('input', function () { field.dataset.customerEdited = '1'; });
  }
  function modelChoices(form, context) {
    if (!form) return;
    var choices = Array.from(form.querySelectorAll('[data-bespoke-model-choice]'));
    if (!choices.length) return;
    var clean = function (s) { return (s || '').trim().toLowerCase().replace(/\s+/g, ' '); };
    var source = safeSource(context.source);
    var handle = source ? new URL(source).pathname.split('/').filter(Boolean).pop() : '';
    var matches = choices.filter(function (choice) {
      return (handle && choice.dataset.modelHandle === handle) ||
        (context.model && (clean(choice.value) === clean(context.model) || clean(choice.dataset.modelName) === clean(context.model)));
    });
    // Preserve restored checkbox state, otherwise preselect the referring product.
    if (!choices.some(function (choice) { return choice.checked; }) && matches.length === 1) matches[0].checked = true;
    var summary = form.querySelector('[data-bespoke-model-summary]');
    function sync() {
      if (!summary) return;
      var selectedModels = choices.filter(function (choice) { return choice.checked; }).map(function (choice) { return choice.value; });
      summary.value = selectedModels.join('; ');
      summary.disabled = selectedModels.length === 0;
    }
    choices.forEach(function (choice) { choice.addEventListener('change', sync); });
    sync();
  }
  function bootProduct(root) {
    if (products.has(root)) return;
    var scope = root.closest('main') || document.querySelector('main') || document.body;
    var template = root.querySelector('[data-bespoke-card-template]');
    var dialog = root.querySelector('dialog');
    if (!template || !dialog) return;
    var form = dialog.querySelector('form');
    var card, configuration, covering, picker, frame;
    rememberModelEdits(form);
    function context() {
      return { model: root.dataset.bespokeModelName || '', configuration: selected(configuration), covering: selected(covering), source: root.dataset.bespokeProductUrl || '' };
    }
    function syncLinks() {
      var href = pageUrl(root, context());
      if (card && card.getAttribute('href') !== href) card.setAttribute('href', href);
      var link = dialog.querySelector('[data-bespoke-page-link]');
      if (link && link.getAttribute('href') !== href) link.setAttribute('href', href);
    }
    function open(event) {
      syncLinks();
      // Modified clicks remain ordinary links to the dedicated enquiry page.
      if (event && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return;
      if (typeof dialog.showModal !== 'function') return;
      if (event) { event.preventDefault(); event.stopPropagation(); }
      setContext(form, context());
      dialog.showModal();
      document.documentElement.classList.add('cd-bespoke-open');
      var focusTarget = dialog.querySelector('[data-bespoke-errors], [data-bespoke-success]') || dialog.querySelector('[data-bespoke-dialog-heading]');
      if (focusTarget) focusTarget.focus();
    }
    dialog.querySelector('[data-bespoke-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () {
      if (!document.querySelector('.cd-bespoke__dialog[open]')) document.documentElement.classList.remove('cd-bespoke-open');
      if (card && card.isConnected) card.focus();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    function change(event) { if (picker && picker.contains(event.target)) syncLinks(); }
    scope.addEventListener('change', change);
    function mount() {
      if (!root.isConnected) {
        observer.disconnect(); scope.removeEventListener('change', change);
        if (dialog.open) dialog.close();
        if (card) card.remove();
        products.delete(root); return;
      }
      picker = Array.from(scope.querySelectorAll('variant-selects')).find(function (candidate) {
        return !candidate.closest('dialog, quick-add-modal') && control(candidate, 'configuration') && control(candidate, 'seat covering');
      });
      if (!picker) return;
      configuration = control(picker, 'configuration'); covering = control(picker, 'seat covering');
      if (!card || !configuration.contains(card)) {
        if (card) card.remove();
        card = template.content.firstElementChild.cloneNode(true);
        card.addEventListener('click', open);
        configuration.append(card);
      }
      syncLinks();
    }
    var observer = new MutationObserver(function () {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(mount);
    });
    observer.observe(scope, { childList: true, subtree: true });
    products.set(root, { mount: mount });
    mount();
    // Only Shopify's server-rendered success/errors can open a post-submit result.
    // Native contact redirects need not preserve a custom query parameter.
    if (dialog.querySelector('[data-bespoke-errors], [data-bespoke-success]')) open();
  }
  function bootContact(root) {
    if (pages.has(root)) return;
    pages.add(root);
    var params = new URLSearchParams(location.search);
    var value = function (key) { return (params.get(key) || '').slice(0, 200); };
    var form = root.querySelector('form');
    var context = { model: value('model'), configuration: value('configuration'), covering: value('covering'), source: params.get('source') || '' };
    setContext(form, context);
    modelChoices(form, context);
    rememberModelEdits(form);
    var result = root.querySelector('[data-bespoke-errors], [data-bespoke-success]');
    if (result) result.focus();
  }
  function boot() {
    document.querySelectorAll('[data-bespoke-product]').forEach(bootProduct);
    document.querySelectorAll('[data-bespoke-contact]').forEach(bootContact);
  }
  window.CinemaDecoBespoke = { boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
